import React from 'react';

const PagesTemplate = ({ rowData }) => {
  return (
    <>
      <span className="p-column-title text-break">Pages</span>
      <span className="text-muted">{rowData?.entry_type === 'folder' || !rowData?.page_count ? '-' : rowData.page_count}</span>
    </>
  );
};

export default PagesTemplate;
